module.exports = __webpack_public_path__ + "static/media/google-btn.0e8a795d.jpg";